import EmptyStateImage from '../assets/empty_state.png'
import styles from './InsightsEmptyState.module.scss'
import { type FC } from 'react'

export const InsightsEmptyState: FC = () => {
  return (
    <div className={styles.container}>
      <img src={EmptyStateImage} alt='No Insights' className={styles.image} />
      <div>
        <h5 className={styles.title}>No meetings captured in this period</h5>
        <p className={styles.subtitle}>Try selecting a wider time range</p>
      </div>
    </div>
  )
}
